<template>
  <div class="c-input" @click="toggleOptions">
    <label
      class="c-input__label"
      :class="{ 'c-input__label--empty': isDirty }"
      :style="{ color: labelColor }"
      >{{ label }}</label
    >
    <div class="c-input__cnt">
      <input
        type="text"
        :value="val"
        :style="{ color: primaryColor }"
        @input="$emit('input', $event.target.value)"
        class="c-input__input"
        disabled
        hidden
      />
      <input
        type="text"
        :value="selectedOptionValue"
        :style="{ color: primaryColor }"
        class="c-input__input"
        disabled
      />
      <select v-if="!standard" @change="onChange" ref="select">
        <option v-for="option in options" :key="option.key">{{
          option.text
        }}</option>
      </select>
      <div class="c-select" v-if="standard">
        <i v-if="isOpen" class="fas fa-chevron-up chevron"></i>
        <i v-else class="fas fa-chevron-down chevron"></i>
        <div v-if="isOpen" class="c-select__options">
          <div
            class="c-select__option"
            v-for="(option, index) in options"
            :key="index"
            @click="
              $emit('input', option.value);
              selectedOptionValue = option.text;
            "
          >
            {{ option.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "InputSelect",
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    standard: {
      type: Boolean,
      default: false
    },
    labelColor: {
      type: String
    },
    primary: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default() {
        return this.$i18n.t("Rispondi qui");
      }
    }
  },
  data() {
    return {
      val: "",
      selected: "",
      isOpen: false,
      selectedOptionValue: ""
    };
  },
  computed: {
    ...mapGetters(["campaign"]),
    isDirty() {
      if (!this.val) {
        return false;
      }
      return this.val.length;
    },
    primaryColor() {
      if (this.primary) {
        return this.campaign.css_settings.primary;
      }
      return "";
    }
  },
  methods: {
    onChange(e) {
      this.$emit("input", e.target.value);
    },
    toggleOptions() {
      this.isOpen = !this.isOpen;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
        const optionValue = this.options.filter(item => item.value === val)[0];
        this.selectedOptionValue = optionValue ? optionValue.text : undefined;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./inputs";
select {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 5;
  color: transparent;
  width: 100%;
  background-color: transparent;
  border: transparent;
}
.c-select {
  .chevron {
    position: absolute;
    right: 5px;
    top: 0;
    cursor: pointer;
  }
}
.c-select__options {
  overflow-y: auto;
  max-height: 200px;
  text-align: left;
  border: 2px solid #e8e8e8;
  border-top: unset;
  position: absolute;
  top: 100%;
  width: 100%;
  background-color: #fff;
}
.c-select__option {
  padding: 10px 5px;
  border-top: 2px solid #e8e8e8;
  font-weight: bold;
  &:first-of-type {
    border-top: none;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>
